export enum CATEGORY_TYPES {
  emotion = 'emotion',
  genre = 'genre',
  instrument = 'instrument',
  video_topic = 'video_topic',
  tag = 'tag',
  sfx_type = 'sfx_type'
}
